<mat-form-field class="w-full">
  <mat-label>Participants who played at this venue</mat-label>
  <input
    matInput
    type="text"
    [formControl]="searchControl"
    [matAutocomplete]="playersAuto"
    (focus)="open()"
    placeholder="Search by name, email, or phone"
    autocomplete="off"
  />
  <mat-icon matSuffix *ngIf="!loading">search</mat-icon>
  <mat-progress-spinner matSuffix *ngIf="loading" diameter="20" mode="indeterminate" />
  <button
    mat-icon-button
    matSuffix
    type="button"
    *ngIf="searchControl.value"
    (click)="clear()"
    aria-label="Clear player search"
  >
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>

<mat-autocomplete #playersAuto="matAutocomplete" (optionSelected)="select($event)">
  <cdk-virtual-scroll-viewport
    class="h-64"
    itemSize="64"
    minBufferPx="256"
    maxBufferPx="512"
    (scrolledIndexChange)="loadWhenNearEnd($event)"
  >
    <mat-option
      *cdkVirtualFor="let player of players"
      [value]="player"
      [disabled]="isExcluded(player._id)"
      class="!h-16"
    >
      <div class="flex items-center gap-3">
        <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-300 text-xs font-semibold">
          {{ player.name?.charAt(0)?.toUpperCase() }}
        </div>
        <div class="min-w-0 flex-1">
          <div class="truncate font-medium">{{ player.name }}</div>
        </div>
        <span *ngIf="isExcluded(player._id)" class="text-xs text-gray-500">Already added</span>
      </div>
    </mat-option>
  </cdk-virtual-scroll-viewport>
  <mat-option *ngIf="!loading && players.length === 0" disabled>
    No matching players have played at this venue.
  </mat-option>
</mat-autocomplete>
